module.exports = __webpack_public_path__ + "files/7789cb285e0fdd866795f0fb8f19264f.woff2";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/open-sans-v13-latin-ext_latin_cyrillic-ext_greek-ext_greek_cyrillic_vietnamese-800italic.woff2
 ** module id = 975
 ** module chunks = 0
 **/